import React, { useEffect } from "react";
import {
  DEFAULT_FORM_FIELD_ATTRIBUTE,
  VALIDATION_ERROR_NAVIGATION_DELAY_MS,
} from "./constants";
import {
  focusFormField,
  type ValidationErrorItem,
} from "./validationSummaryUtils";

export interface SlidePanelValidationEffectsProps {
  errorItems: ValidationErrorItem[];
  activeErrorIndex: number;
  pendingFocusField?: string;
  onActiveErrorIndexChange: (index: number) => void;
  onPendingFocusHandled: () => void;
  fieldAttribute?: string;
}

const SlidePanelValidationEffects: React.FC<
  SlidePanelValidationEffectsProps
> = ({
  errorItems,
  activeErrorIndex,
  pendingFocusField,
  onActiveErrorIndexChange,
  onPendingFocusHandled,
  fieldAttribute = DEFAULT_FORM_FIELD_ATTRIBUTE,
}) => {
  useEffect(() => {
    if (!errorItems.length) return;
    if (activeErrorIndex < errorItems.length) return;
    onActiveErrorIndexChange(errorItems.length - 1);
  }, [activeErrorIndex, errorItems.length, onActiveErrorIndexChange]);

  useEffect(() => {
    if (!pendingFocusField) return;

    const targetField =
      errorItems.find(item => item.name === pendingFocusField)?.name ??
      errorItems[0]?.name ??
      pendingFocusField;

    if (!targetField) return;

    const timeout = window.setTimeout(() => {
      focusFormField(targetField, { fieldAttribute });
      onPendingFocusHandled();
    }, VALIDATION_ERROR_NAVIGATION_DELAY_MS);

    return () => window.clearTimeout(timeout);
  }, [errorItems, fieldAttribute, onPendingFocusHandled, pendingFocusField]);

  return null;
};

export default SlidePanelValidationEffects;
